import { createMuiTheme } from '@material-ui/core'

const marketsColour = '#008C9F'
export default createMuiTheme({
  overrides: {
    MuiPickersDay: {
      daySelected: {
        backgroundColor: marketsColour,
        '&:hover': {
          backgroundColor: marketsColour
        }
      },
      current: {
        color: marketsColour
      }
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: marketsColour
      }
    },
    MuiPickersYear: {
      yearSelected: {
        color: marketsColour
      }
    },
    MuiPickersMonth: {
      monthSelected: {
        color: marketsColour
      }
    },
    MuiInputBase: {
      root: {
        cursor: 'pointer'
      },
      input: {
        cursor: 'pointer',
        userSelect: 'none'
      }
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: 'white',
        '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
          borderColor: marketsColour
        },
        '&$focused $notchedOutline': {
          borderColor: marketsColour
        }
      }
    },
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: marketsColour
        }
      }
    }
  }
})
